import { Routes, Route } from "react-router-dom";
import "@/App.css";
import Home from "@/components/Home";
import AdminPage from "@/components/AdminPage";
import MerchWheelDemo from "@/components/MerchWheelDemo";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/merch-wheel-demo" element={<MerchWheelDemo />} />
    </Routes>
  );
}

export default App;
